<div class="with-header">
    <header cdx-header>
        <cdx-header-product-name>Your Application - FTF Widget Demo v{{ widgetVersion }}</cdx-header-product-name>
        <cdx-header-global></cdx-header-global>
    </header>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</div>
<footer cdx-footer></footer>